export const initFaq = () => {
  const faqList = document.querySelector('.faq__list');

  if (!faqList) return;

  const items = Array.from(faqList.querySelectorAll('.faq__item'));

  items.forEach(item => {
    const button = item.querySelector('.faq__question');
    const answer = item.querySelector('.faq__answer');

    if (!button || !answer) return;

    button.setAttribute('aria-expanded', 'false');
    answer.hidden = true;
    item.classList.remove('faq__item--expanded');
  });

  faqList.addEventListener('click', event => {
    const button = event.target.closest('.faq__question');

    if (!button) return;

    const item = button.closest('.faq__item');
    const answer = item?.querySelector('.faq__answer');

    if (!item || !answer) return;

    const isExpanded = button.getAttribute('aria-expanded') === 'true';

    items.forEach(otherItem => {
      if (otherItem === item) return;
      const otherButton = otherItem.querySelector('.faq__question');
      const otherAnswer = otherItem.querySelector('.faq__answer');

      if (!otherButton || !otherAnswer) return;

      otherButton.setAttribute('aria-expanded', 'false');
      otherAnswer.hidden = true;
      otherItem.classList.remove('faq__item--expanded');
    });

    const nextState = !isExpanded;

    button.setAttribute('aria-expanded', String(nextState));
    answer.hidden = !nextState;
    item.classList.toggle('faq__item--expanded', nextState);
  });
};
